var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTargetGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-5 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(6.003336 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.076665 15.92-5.02 5.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.9966645 8v8h8l8-8-5.334-2.666-2.666-5.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9966645 3.94999999h.0000002c-9.39326001.576524-16.54062001 8.65862001-15.96410001 18.05188001.576524 9.39326 8.65862 16.54062 18.05188001 15.9641 8.58962-.5272 15.43798-7.3763 15.96422-15.96598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4166645 22c-.566558 5.18824-5.23176 8.93486-10.42 8.3683-5.18824-.566558-8.93486002-5.23176-8.36830002-10.42.481246-4.407 3.96130002-7.88706 8.36830002-8.3683"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetGoal);
export default __webpack_public_path__ + "static/media/target-goal.c237c4c77d97c023d1d68c5b06eaa440.svg";
export { ForwardRef as ReactComponent };